export default __webpack_public_path__ + "static/media/support-us.1f896e95.jpg";